let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("arXo9")).then(() => parcelRequire('e65rL'));